import React from "react";
import styles from "./Zoom.module.scss";
import add from "../../Container/plus.svg";
import minus from "../../Container/minus.svg";
import add_white from "../../Container/plus_white.svg"
import minus_white from "../../Container/minus_white.svg"


class Zoom extends  React.Component{
    render(){
        return (
            <div className={`zoomControl ${this.props.mapview ? 'bg_blue' : 'bg_white'}`} onMouseOver={() => this.props.zoomHoverTrue()} onMouseLeave={() => this.props.zoomLeaveTrue()}>
            {
                this.props.isHover ? (
                    <React.Fragment>
                        <div className={styles.zoomin_btn}>
                            <img onClick={this.props.zoomControl} src={this.props.mapview ? add : add_white} alt="add" key="1"></img>
                            <span className={styles.zoomin_tooltip}>Zoom In</span>
                        </div>
                        <div className={styles.zoomout_btn}>
                            <img onClick={this.props.zoomOutControl} src={this.props.mapview ? minus : minus_white} alt="minus" key="2"></img>
                            <span className={styles.zoomout_tooltip}>Zoom Out</span>
                        </div>
                    </React.Fragment>

                ) : (
                    <React.Fragment>
                        <div className={styles.zoomin_btn}>
                            <img onClick={this.props.zoomControl} src={this.props.mapview ? add_white : add} alt="add" key="3"></img>
                            <span className={styles.zoomin_tooltip}>Zoom In</span>
                        </div>
                        <div className={styles.zoomout_btn}>
                            <img onClick={this.props.zoomOutControl} src={this.props.mapview ? minus_white : minus} alt="minus" key="4"></img>
                            <span className={styles.zoomout_tooltip}>Zoom Out</span>
                        </div>
                    </React.Fragment>
                )
            }
        </div>
        );
    }
}


export default Zoom;